/**
 * Utilidades de fecha en zona horaria ESTRICTA America/Mexico_City.
 *
 * CRÍTICO: NO usar `new Date().toISOString().slice(0, 10)` — esa función convierte
 * la fecha a UTC antes de formatear. En México (UTC-6) a las 6pm el sistema
 * cambiaría de día. Estas funciones fuerzan la zona horaria de México usando
 * `Intl.DateTimeFormat`, garantizando que el cambio de día ocurra a las 00:00
 * hora local de México sin importar la zona del navegador.
 */

const TZ_MEXICO = 'America/Mexico_City';

/** Formatea un Date como YYYY-MM-DD en la zona horaria de México. */
function _fmtMexico(d) {
  // 'en-CA' produce el formato YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_MEXICO,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

/** Fecha de HOY en formato YYYY-MM-DD, zona horaria America/Mexico_City. */
export function hoyLocal() {
  return _fmtMexico(new Date());
}

/** Convierte un Date/fecha a YYYY-MM-DD en zona horaria de México. */
export function fechaLocal(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return _fmtMexico(d);
}

/** Mes actual en formato YYYY-MM, zona horaria de México. */
export function mesLocal() {
  return hoyLocal().slice(0, 7);
}

/**
 * Suma (o resta si es negativo) días a una fecha YYYY-MM-DD usando aritmética
 * de calendario pura (sin conversiones de zona horaria).
 */
export function sumarDias(fechaStr, dias) {
  const [y, m, d] = String(fechaStr).split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + dias);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(dt.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** Devuelve fecha YYYY-MM-DD `dias` en el futuro (o pasado) desde hoy México. */
export function hoyMasDias(dias) {
  return sumarDias(hoyLocal(), dias);
}
